import { Text } from '@mantine/core';

type TicketPreviewContentProps = {
  mode: 'html' | 'text';
  content: string;
  error?: string | null;
  maxWidth?: number;
};

const TicketPreviewContent = ({
  mode,
  content,
  error,
  maxWidth,
}: TicketPreviewContentProps) => {
  return (
    <>
      {error && (
        <Text c="orange" size="sm" mb="sm">
          {error}
        </Text>
      )}
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        {mode === 'text' ? (
          <pre
            style={{
              width: '100%',
              maxWidth,
              margin: 0,
              padding: 16,
              background: '#fff',
              color: '#000',
              border: '1px dashed #c5c5c5',
              fontFamily: 'monospace',
              fontSize: 12,
              lineHeight: 1.5,
              whiteSpace: 'pre-wrap',
              overflowX: 'auto',
            }}
          >
            {content}
          </pre>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </div>
    </>
  );
};

export default TicketPreviewContent;
